import { Skeleton } from '@chakra-ui/react';
import React from 'react';
import { Switch, Route } from 'react-router-dom';

import { FundingRequestApproveRoute } from './FundingRequestApproveRoute';
import { FundingRequestRoute } from './FundingRequestRoute';
import { FundingRequestHistoryWithVerificationRoute } from 'packages/funding-requests/routes/FundingRequestHistoryWithVerificationRoute';
import { VerificationEligibilityRoute } from 'packages/funding-requests/routes/VerificationEligibilityRoute';
import { VerificationHistoryRoute } from 'packages/funding-requests/routes/VerificationHistoryRoute';
import { VerificationWorkflowRoute } from 'packages/funding-requests/routes/VerificationWorkflowRoute';
import { useGetLenderVerificationCreditFacilitiesQuery } from 'packages/verifications/requests/requests.gql.generated';
import { baseNewVerificationUrl } from 'packages/verifications/ui/VerificationsTemplate';

export const FundingRequestRouter: React.FC<{ organizationId: string }> = ({
  organizationId,
}) => {
  const {
    data: creditFacilitiesData,
  } = useGetLenderVerificationCreditFacilitiesQuery({
    variables: { organizationId },
  });
  if (
    !creditFacilitiesData ||
    !creditFacilitiesData.lenderVerificationCreditFacilities
  ) {
    return (
      <Skeleton
        data-testid="loading-lender-verification-container"
        height="300px"
      />
    );
  }

  const { lenderVerificationCreditFacilities } = creditFacilitiesData;
  const enableVerifications = !!lenderVerificationCreditFacilities.length;

  return (
    <Switch>
      {/* --- Funding verification routes --- */}
      {enableVerifications && (
        <Route
          exact
          path={baseNewVerificationUrl}
          component={VerificationWorkflowRoute}
        />
      )}
      {enableVerifications && (
        <Route
          exact
          path="/funding-requests/verifications/pipeline/history"
          component={VerificationHistoryRoute}
        />
      )}
      {enableVerifications && (
        <Route
          exact
          path="/funding-requests/verifications/pipeline/:artifactDocumentId/:creditFacilityId/:reportingDate/:fileVersion"
          component={VerificationWorkflowRoute}
        />
      )}
      {enableVerifications && (
        <Route
          exact
          path="/funding-requests/verifications/pipeline/:artifactDocumentId/:creditFacilityId/:reportingDate/:fileVersion/:verificationReportId/eligibility"
          component={VerificationEligibilityRoute}
        />
      )}

      {/* --- Funding request routes --- */}
      <Route exact path="/funding-requests">
        <FundingRequestHistoryWithVerificationRoute
          enableVerifications={enableVerifications}
        />
      </Route>
      <Route
        exact
        path="/funding-requests/:fundingRequestId"
        component={FundingRequestRoute}
      />
      <Route
        exact
        path="/funding-requests/:fundingRequestId/approve"
        component={FundingRequestApproveRoute}
      />
    </Switch>
  );
};
